import React from "react";
import { Outlet, useOutletContext } from "react-router";

const ReportsMain = () => {
  const { tenantName } = useOutletContext();

  return (
    <Outlet
      context={{
        tenantName,
      }}
    />
  );
};

export default ReportsMain;
